<template>
  <div class="item">
    <LazyLoader ref="lazy" api-key="actRec" @init="fetch">
      <Observer v-if="acts.length" class="active" @show="reportShow">
        <div class="h-tt">
          <h2>活动推荐</h2>
        </div>
        <ul class="active-list">
          <li v-for="(item, i) in acts" :key="item.id">
            <img :src="item.img_url" />
            <div class="info">
              <p class="t1">{{ item.title }}</p>
              <p class="t2">{{ item.description }}</p>
              <a
                href="javascript:;"
                class="btn"
                @click="
                  $util.bannerJump(item)
                  reportClick(item, i)
                "
              >
                免费领取
              </a>
            </div>
          </li>
        </ul>
      </Observer>
      <template v-slot:skeleton="{ error, loading }">
        <div class="active">
          <div class="h-tt"></div>
          <ul class="active-list">
            <li v-for="i in 3" :key="i">
              <Skeleton :error="error" :loading="loading" @retry="fetch" />
            </li>
          </ul>
        </div>
      </template>
    </LazyLoader>
  </div>
</template>

<script>
export default {
  data() {
    return {
      acts: []
    }
  },
  methods: {
    reportShow() {
      this.acts.forEach((e, i) => {
        this.$xlaPush('home_page_banner_content_show', {
          rn: i,
          ...this.getExtData(e)
        })
      })
    },
    reportClick(e, i) {
      this.$xlaPush('home_page_banner_content_click', {
        rn: i,
        ...this.getExtData(e)
      })
    },
    getExtData(e) {
      const isGame = Global.CONS.CollectionType.game === e.collection_type
      return {
        area: 'middle',
        game_id: isGame ? e.game_id : 'other',
        game_name: isGame ? e.title : 'other',
        url: e.jump_url
      }
    },
    fetch() {
      this.$request('actRec').then((data) => (this.acts = data || []))
    },
    jump(url) {
      window.open(url)
    }
  }
}
</script>
